import type { TemplateFormField } from '@common/types/templateFormFields';
import {
    DUPLICATE_CONTACT_EMAIL_ERROR,
    DUPLICATE_CONTACT_EMAIL_SNACKBAR,
    getDuplicateEmailIndices,
    hasDuplicateContactEmails,
    normalizeContactEmail,
    syncDuplicateContactEmailErrors,
} from '@common/utils/contactEmails';

export {
    DUPLICATE_CONTACT_EMAIL_ERROR,
    DUPLICATE_CONTACT_EMAIL_SNACKBAR,
    getDuplicateEmailIndices,
    hasDuplicateContactEmails,
    normalizeContactEmail,
    syncDuplicateContactEmailErrors,
};

export function syncDuplicateEmailErrorsInWrappedContacts(
    stores: TemplateFormField[][],
    count: number,
    duplicateEmailError: string = DUPLICATE_CONTACT_EMAIL_ERROR,
): void {
    const activeStores = stores.slice(0, count);
    const duplicateIndices = new Set(
        getDuplicateEmailIndices(
            activeStores.map((store) => getEmailFromTemplateFormFields(store)),
        ),
    );

    activeStores.forEach((contactFields, index) => {
        const emailField = contactFields.find((field) => field.name === 'email');
        if (!emailField) return;

        if (duplicateIndices.has(index)) {
            emailField.questionSchema.isError = true;
            emailField.questionSchema.helper = duplicateEmailError;
        } else if (emailField.questionSchema.helper === duplicateEmailError) {
            emailField.questionSchema.isError = false;
            emailField.questionSchema.helper = '';
        }
    });
}

export function getEmailFromTemplateFormFields(fields: TemplateFormField[] | undefined): string {
    const value = fields?.find((item) => item.name === 'email')?.questionSchema?.value;
    return value?.toString().trim() ?? '';
}

export function getEmailsFromWrappedContacts(
    stores: TemplateFormField[][],
    count: number,
): string[] {
    return stores.slice(0, count).map((store) => getEmailFromTemplateFormFields(store));
}

export function getLowestGroupsLowestEl() {
    const formGroupsCount = 10;
    let lowest: any = null;

    for (let i = 0; i <= formGroupsCount; i++) {
        const formGroupItems = document.querySelectorAll(`[data-formgroup-index="${i}"]`);
        for (let item = 0; item < formGroupItems.length; item++) {
            let order: any = formGroupItems[item].getAttribute('data-is-error');
            order = parseInt(order, 10);

            if (lowest === null || order < parseInt(lowest?.getAttribute('data-is-error'), 10)) {
                lowest = formGroupItems[item];
            }
        }

        if (lowest) {
            break;
        }
    }

    return lowest;
}

export function scrollToError() {
    const els = document.querySelectorAll('[data-is-error]');
    let lowest: any = els.length ? els[0] : null;
    for (let i = 0; i < els.length; i++) {
        let order: any = els[i].getAttribute('data-is-error');
        order = parseInt(order, 10);
        lowest = lowest.getAttribute('data-is-error') > order ? els[i] : lowest;
    }
    return lowest;
}

export function initScroll(el: Element | null) {
    if (el) {
        window.setTimeout(() => {
            el.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
        }, 1000);
    }
}
